import React from 'react';
import { useLocation, useSearchParams } from 'react-router-dom';

const withLocation = WrappedComponent => {
  function WithLocation(props) {
    const location = useLocation();
    const [query] = useSearchParams();
    location.query = Object.fromEntries(query.entries());
    return <WrappedComponent {...props} location={location} />;
  }
  WithLocation.displayName = `withLocation(${WrappedComponent.displayName || WrappedComponent.name || 'Component'})`;
  return WithLocation;
};

export default withLocation;
